module.exports = __webpack_public_path__ + "img/sys2.16b52613.png";